module.exports = __webpack_public_path__ + "static/media/4.13de1167.jpg";